import { ToastContainer, Flip, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Game } from "./components/Game";
import React, { useEffect, useMemo, useState } from "react";
import { Infos } from "./components/panels/Infos";
import { useTranslation } from "react-i18next";
import { Settings } from "./components/panels/Settings";
import { useSettings } from "./hooks/useSettings";
import { PobleCV } from "./components/PobleCV";
import { Stats } from "./components/panels/Stats";
import { useReactPWAInstall } from "@teuteuf/react-pwa-install";
import { InstallButton } from "./components/InstallButton";
import { Twemoji } from "react-emoji-render";
import { getDayString, useTodays } from "./hooks/useTodays";
import {
  LocalStoragePersistenceService,
  ServiceWorkerUpdaterProps,
  withServiceWorkerUpdater,
} from "@3m1/service-worker-updater";

const supportLink: Record<string, string> = {
  UA: "https://donate.redcrossredcrescent.org/ua/donate/~my-donation?_cv=1",
};

function App({
  newServiceWorkerDetected,
  onLoadNewServiceWorkerAccept,
}: ServiceWorkerUpdaterProps) {
  const { t, i18n } = useTranslation();

  const dayString = useMemo(getDayString, []);
  const [{ town }] = useTodays(dayString);

  const { pwaInstall, supported, isInstalled } = useReactPWAInstall();

  const [infoOpen, setInfoOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [statsOpen, setStatsOpen] = useState(false);

  const [settingsData, updateSettings] = useSettings();

  /*useEffect(() => {
    if (newServiceWorkerDetected) {
      toast.info(t("updatingVersion"));
      onLoadNewServiceWorkerAccept();
    }
  }, [newServiceWorkerDetected, onLoadNewServiceWorkerAccept, t]);*/

  useEffect(() => {
    if (settingsData.theme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [settingsData.theme]);

  return (
    <>
      <ToastContainer
        hideProgressBar
        position="top-center"
        transition={Flip}
        theme={settingsData.theme}
        autoClose={2000}
        bodyClassName="font-bold text-center"
      />
      <Infos
        isOpen={infoOpen}
        close={() => setInfoOpen(false)}
        settingsData={settingsData}
      />
      <Settings
        isOpen={settingsOpen}
        close={() => setSettingsOpen(false)}
        settingsData={settingsData}
        updateSettings={updateSettings}
      />
      <Stats
        isOpen={statsOpen}
        close={() => setStatsOpen(false)}
        distanceUnit={settingsData.distanceUnit}
      />
      <div className="flex justify-center flex-auto dark:bg-slate-900 dark:text-slate-50">
        <div className="w-full max-w-lg flex flex-col">
          <header className="items-center border-b-2 px-3 border-gray-200 flex">
            <button
              className="mr-3 text-xl"
              type="button"
              onClick={() => setInfoOpen(true)}
            >
              <Twemoji text="❓" />
            </button>
            {supported() && !isInstalled() && (
              <InstallButton pwaInstall={pwaInstall} />
            )}
            
            <a 
              className="text-4xl font-bold uppercase tracking-wide text-center my-1 flex-auto"
              href="https://www.apuntmedia.es"
              target="_blank"
              rel="noopener noreferrer"
            ><img src="apunt.svg" width="30px" className="dark:invert"></img></a>

            <h1 className="text-4xl font-bold uppercase tracking-wide text-center my-1 flex-auto">
              POB<span className="text-green-600">LE</span><span className="text-gray-400"><sup className="text-2xl">CV</sup></span>
            </h1>
            <button
              className="ml-3 text-xl"
              type="button"
              onClick={() => setStatsOpen(true)}
            >
              <Twemoji text="📈" />
            </button>
            <button
              className="ml-3 text-xl"
              type="button"
              onClick={() => setSettingsOpen(true)}
            >
              <Twemoji text="⚙️" />
            </button>
          </header>
          <Game settingsData={settingsData} updateSettings={updateSettings} />
          <footer className="flex justify-center items-center text-sm mt-8 mb-1">
          <a 
            href="https://www.apuntmedia.es"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="apunt.svg" width="25px" className="dark:invert"></img>
          </a>
          &nbsp; <Twemoji
              text="❤️"
              className="flex items-center justify-center mr-1"
            />{" "}
            <PobleCV />
          </footer>
        </div>
      </div>
    </>
  );
}

export default withServiceWorkerUpdater(App, {
  persistenceService: new LocalStoragePersistenceService("worldle"),
});
